import {useMemo} from "react";

import {useStoredMe} from "@/src/modules/core/store/me";

import {isAlertsBellTopic, isResidentBellTopic} from "../lib/notification-feed-topics";
import {useNotificationFeedStore} from "../store";

/** Unread alert rows (shift, stored vehicle, briefing board) — excludes direct_message. */
export function useAlertsFeedUnreadCount() {
  const items = useNotificationFeedStore((state) => state.items);

  return useMemo(
    () =>
      items.filter(
        (item) =>
          isAlertsBellTopic(item.topic) && !item.read_at && !item.discarded_at,
      ).length,
    [items],
  );
}

/** Bell badge: residents count DM + household; staff counts alerts only (DM badge is separate). */
export function useBellUnreadCount() {
  const me = useStoredMe();
  const isResident = Boolean(me?.isResident);
  const items = useNotificationFeedStore((state) => state.items);

  return useMemo(
    () =>
      items.filter((item) => {
        if (item.read_at || item.discarded_at) {
          return false;
        }
        return isResident ? isResidentBellTopic(item.topic) : isAlertsBellTopic(item.topic);
      }).length,
    [items, isResident],
  );
}
